import React from 'react'
import { Link } from 'react-router-dom'

const Button = ({
  to,
  color,
  children,
  onClick,
  className,
  title,
  disabled,
  id
}) => {
  if (to)
    return (
      <Link
        to={to}
        className={
          'custom-button ' + (color ? color : 'primary') + ' ' + className
        }
        title={title}
      >
        {children}
      </Link>
    )
  else
    return (
      <button
        id={id}
        onClick={onClick}
        className={
          'custom-button ' + (color ? color : 'primary') + ' ' + className
        }
        title={title}
        disabled={disabled || false}
      >
        {children}
      </button>
    )
}

export default Button
